import { isNil, pathOr } from 'ramda';

import { revokeComingFromUrl } from '@gef-ui/delegations/utils';
import { getIascData } from '@gef-ui/features/iasc/selectors';
import { getMessage } from '@gef-ui/localization/messages';

import { subheaders } from 'features/common/Subheader/constants';
import { setVisibleState } from 'features/common/Subheader/slice';
import taskOverview from 'features/views/taskOverview';
import { getRoutePath, history } from 'utils';

// eslint-disable-next-line import/no-cycle
import { errorRedirect } from '../actions';
// eslint-disable-next-line import/no-cycle
import { REDIRECT_INFO } from '../constants';

const checkInputParams = (taskTypeId, info) => {
	const errMsgs = [];
	if (isNil(taskTypeId) && info !== REDIRECT_INFO) {
		errMsgs.push(getMessage('iasErrors:missingRequiredParam', { paramName: 'taskTypeId' }));
	}
	return errMsgs;
};

export default (dispatch, getState) => {
	const { taskTypeId } = getIascData(getState());
	const info = pathOr('0', ['info'], getIascData(getState()));
	const errMsgs = checkInputParams(taskTypeId, info);
	if (errMsgs.length > 0) {
		dispatch(errorRedirect(errMsgs));
		throw {};
	} else {
		if (info === REDIRECT_INFO) {
			dispatch(taskOverview.actions.changeQuickFilterView('info'));
		} else {
			const subheaderId = `${subheaders.tasksOverview}_type_${taskTypeId}`;
			dispatch(setVisibleState({ id: subheaderId, visible: true }));
		}
		revokeComingFromUrl();
		history.push(getRoutePath('tasks'));
	}
};
